module.exports = __webpack_public_path__ + "static/media/html5Icon.d22bcaa3.svg";